import { render, staticRenderFns } from "./index - 副本.vue?vue&type=template&id=7a5a81f8&scoped=true&"
import script from "./index - 副本.vue?vue&type=script&lang=js&"
export * from "./index - 副本.vue?vue&type=script&lang=js&"
import style0 from "./index - 副本.vue?vue&type=style&index=0&id=7a5a81f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5a81f8",
  null
  
)

export default component.exports